module.exports = __webpack_public_path__ + "img/slider-prev.22025521.svg";